module.exports = {"id":"173436","name":"Nathan Dyer","rating":"75","photo":"./data/images/photos/2/173436.png","club":{"name":"Swansea City","logo":"./data/images/clubs/SwanseaCity.png"},"positions":["MD","AD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NathanDyer0.json
// module id = 3140
// module chunks = 0